import { LocationVarKey, ReviewInterface } from "@swivl-mono/types";
import { Button, ButtonColor, Spinner, TextArea } from "@swivl-mono/ui";
import { useMemo, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { MdAddComment, MdOutlineAddComment } from "react-icons/md";
import { useNavigate } from "react-router-dom";

import { SelectableList } from "../../../../Components/SelectableList/SelectableList.Component";
import { useLocationVariables } from "../../../../Hooks/useLocationVariables";
import ModalModel from "../../../../Models/Modal/Modal.Model";
import ReviewsModel from "../../../../Models/Reviews/Reviews.Model";
import { ReviewsViewMultiSelectModal } from "./Reviews.View.MultiSelect.Modal";
import "./Reviews.View.MultiSelect.scss";

interface Props {
  reviews: { [id: number]: ReviewInterface };
  clearSelectedReviews: () => void;
}

export function ReviewsViewMultiSelect(props: Props) {
  const { reviews, clearSelectedReviews } = props;
  const count = Object.keys(reviews).length;
  const [replyText, setReplyText] = useState("");
  const [autoCompleteEnabled, setAutoCompleteEnabled] = useState(localStorage.getItem("reviewAutoCompleteEnabled") !== "false" ? true : false);
  const isShowingQuickReplies = true;
  const [isLoadingGeneratedReviewReply, setIsLoadingGeneratedReviewReply] = useState(false);

  const navigate = useNavigate();

  const variables = useLocationVariables([
    LocationVarKey.ReviewReplyGeneral,
    LocationVarKey.ReviewReply5Star,
    LocationVarKey.ReviewReplyPromoter,
    LocationVarKey.ReviewReplyPassive,
    LocationVarKey.ReviewReplyDetractor,
    LocationVarKey.ReviewReply1Star
  ]);

  const hasReviewWithReply = useMemo(
    () =>
      Object.keys(reviews).some((id) => {
        return reviews[id].replyText && reviews[id].replyText.length > 0;
      }),
    [reviews]
  );

  const toggleAutoCompleteEnabled = () => {
    setAutoCompleteEnabled(!autoCompleteEnabled);
    localStorage.setItem("reviewAutoCompleteEnabled", autoCompleteEnabled ? "false" : "true");
  };

  if (hasReviewWithReply) {
    return (
      <div className="ReviewsViewMultiSelect">
        <div className="error">
          <div className="heading">⚠️ Oops!</div>
          <div className="message">
            Please select only reviews
            <br />
            that have no response
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="ReviewsViewMultiSelect">
      <div className="top">
        <div className="heading">Batch Reply</div>
        <AiOutlineClose onClick={clearSelectedReviews} />
      </div>

      <div className="ReviewViewReply">
        <div className="editReplyText">
          <label>You are responding publicly to {count} reviews.</label>
          {isLoadingGeneratedReviewReply ? (
            <div className="loadingGeneratedReviewReply">
              <Spinner />
            </div>
          ) : (
            <TextArea
              placeholder="Add your reply here..."
              rows={20}
              value={replyText}
              onChange={(e: any) => {
                setReplyText(e.target.value);
              }}
            />
          )}
        </div>
        <div className="footer justButtons">
          <div className="actions">
            <div className={isShowingQuickReplies ? "quickReplyButton open" : "quickReplyButton"}>
              {isShowingQuickReplies ? <MdAddComment /> : <MdOutlineAddComment />}
            </div>
            {/* <div
                    className={autoCompleteEnabled ? "autoCompleteButton enabled" : "autoCompleteButton "}
                    onClick={toggleAutoCompleteEnabled}>
                    {autoCompleteEnabled ? <BsLightningChargeFill /> : <BsLightningCharge />}

                </div> */}
          </div>
          <Button onClick={clearSelectedReviews}>Discard</Button>
          <Button
            color={ButtonColor.ORANGE}
            disabled={!replyText.length}
            onClick={() => {
              ReviewsModel.deselectAllReviews();
              ModalModel.showModalWithContent(<ReviewsViewMultiSelectModal reviews={reviews} replyText={replyText} />, 544);
            }}
          >
            Publish ({count}){" "}
          </Button>
        </div>
        <div className={isShowingQuickReplies ? "quickRepliesSpacer show" : "quickRepliesSpacer hide"} />

        <SelectableList
          open={isShowingQuickReplies}
          title="Quick Replies"
          actionButtonText="Manage"
          actionButtonOnClick={() => {
            navigate("/my-storage/ReviewReply");
          }}
          openHeight={130}
          items={
            variables
              ? ([
                  { title: "General Reply", value: variables[LocationVarKey.ReviewReplyGeneral] },

                  { title: "5 Star Review", value: variables[LocationVarKey.ReviewReply5Star] },

                  { title: "Promoter Review", value: variables[LocationVarKey.ReviewReplyPromoter] },

                  { title: "Passive Review", value: variables[LocationVarKey.ReviewReplyPassive] },
                  { title: "Detractor Review", value: variables[LocationVarKey.ReviewReplyDetractor] },

                  { title: "1 Star Review", value: variables[LocationVarKey.ReviewReply1Star] }
                ] as any)
              : []
          }
          onItemSelected={(value) => {
            setReplyText(value);
          }}
          //                 Thank you!
        />
      </div>
    </div>
  );
}
